import { PublicClientApplication } from "@azure/msal-browser";

const msalADConfig = {
	auth: {
		clientId: process.env.REACT_APP_MSAL_AD_CLIENTID,
		authority: process.env.REACT_APP_MSAL_AD_AUTHORITY,
		redirectUri: process.env.REACT_APP_REDIRECT_B2C,
		knownAuthorities: ["ABSAuth.b2clogin.com", process.env.REACT_APP_REDIRECT_B2C],
	},
	cache: {
		cacheLocation: "localStorage",
		storeAuthStateInCookie: false,
	},
	scope: {
		scopes: ["openid", "profile", "offline_access"],
	},
	system: {
		allowRedirectInIframe: true,
	},
};

export const msalADInstance = new PublicClientApplication({
	auth: msalADConfig.auth,
});

const msalB2CConfig = {
	auth: {
		clientId: process.env.REACT_APP_MSAL_B2C_CLIENTID,
		authority: process.env.REACT_APP_MSAL_B2C_AUTHORITY,
		redirectUri: process.env.REACT_APP_REDIRECT_B2C,
		knownAuthorities: [process.env.REACT_APP_KNOWN_AUTHORITIES, process.env.REACT_APP_REDIRECT_B2C],
	},
	cache: {
		cacheLocation: "localStorage",
		storeAuthStateInCookie: false,
	},
	scope: {
		scopes: ["openid", "profile", "offline_access"],
	},
	system: {
		allowRedirectInIframe: true,
	},
};

export const msalB2CInstance = new PublicClientApplication({
	auth: msalB2CConfig.auth,
});
